import React from 'react'
import SimpleLayout from '@src/layouts/SimpleLayout'
import PageLayout from '@src/layouts/PageLayout'
import BlogLayout from '@src/layouts/BlogLayout'
import DevBlogLayout from '@src/layouts/DevBlogLayout'

const LayoutChooser = ({ children, pageContext }) => {
  if (pageContext.layout === 'simple') {
    return <SimpleLayout pageContext={pageContext}>{children}</SimpleLayout>
  } else if (pageContext.layout === 'blog') {
    return <BlogLayout pageContext={pageContext}>{children}</BlogLayout>
  } else if (pageContext.layout === 'dev-blog') {
    return <DevBlogLayout pageContext={pageContext}>{children}</DevBlogLayout>
  }
  return <PageLayout pageContext={pageContext}>{children}</PageLayout>
}

export default LayoutChooser
